<template>
  <div class="genetic">
    <i class="iconfont iconfanhui back" @click.stop="$router.back()">返回</i>
    <div class="title">
      <p>遗传携带 ---</p>
    </div>
    <div class="checkBtn" @click="checkReport">查看报告</div>
  </div>
</template>

<script>
export default {
  name: 'index',
  methods: {
    checkReport () {
      this.$router.push('/geneprotocol')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .genetic {
    width: 100%;
    height: 100%;
    background: url('../../assets/images/genetic/geneticBg.png') no-repeat center;
    background-size: cover;
    position: relative;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .title {
      font-weight: bold;
      position: absolute;
      top: 18%;
      left: 16%;

      p {
        font-size: pxToRem(78px);
        font-weight: 800;
        color: #fff;
        line-height: pxToRem(96px);
        background: linear-gradient(259deg,rgba(99,163,255,1) 0%, rgba(182,220,255,1) 49.7314453125%, rgba(114,190,255,1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .checkBtn {
      padding: pxToRem(15px) pxToRem(30px)  pxToRem(15px)  pxToRem(36px);
      background: url('../../assets/images/ceramide/cerbtn1.png') no-repeat center;
      background-size: 100% 100%;
      font-size: pxToRem(28px);
      color: #fff;
      text-align: center;
      letter-spacing: pxToRem(5px);
      position: absolute;
      top: 71%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/genetic/index.vue